import BoloLogo from '@/components/base/BoloLogo';

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center bg-[#272727] overflow-hidden">
      {/* Subtle texture overlay */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage:
            'linear-gradient(#e9eae4 1px, transparent 1px), linear-gradient(90deg, #e9eae4 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      ></div>

      {/* Olive accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] bg-[#4d4d31]/20 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <BoloLogo className="h-28 w-auto" variant="dark" />
        </div>

        {/* Badge */}
        <div className="inline-flex items-center space-x-2 bg-[#e9eae4]/8 border border-[#e9eae4]/20 rounded-full px-5 py-2 mb-10">
          <span className="w-2 h-2 bg-[#4d4d31] rounded-full animate-pulse inline-block"></span>
          <span className="text-[#e9eae4]/70 text-sm tracking-widest font-barlow uppercase">Published every Thursday</span>
        </div>

        <h1 className="font-antonio text-7xl lg:text-9xl font-bold text-[#e9eae4] mb-6 tracking-tight leading-none uppercase">
          The BOLO Report
        </h1>
        <p className="font-barlow text-2xl lg:text-3xl text-[#e9eae4]/65 font-light mb-6 tracking-widest uppercase">
          Trend Intelligence for Resellers
        </p>
        <p className="font-barlow text-lg text-[#e9eae4]/50 max-w-2xl mx-auto mb-12 leading-relaxed">
          Every Thursday we break down which brands are selling fast online, what to pay for them, and where to sell them — before the rest of the market catches on.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-14">
          <a
            href="https://theboloreport.substack.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#e9eae4] text-[#272727] px-9 py-4 rounded-full text-base font-bold hover:bg-white transition-all hover:-translate-y-0.5 whitespace-nowrap cursor-pointer font-barlow tracking-wide"
          >
            Read the Latest Report
          </a>
          <a
            href="https://theboloreport.substack.com/subscribe?utm_source=menu&simple=true&next=https%3A%2F%2Ftheboloreport.substack.com%2F"
            target="_blank"
            rel="noopener noreferrer"
            className="border-2 border-[#4d4d31] text-[#e9eae4] px-9 py-4 rounded-full text-base font-semibold hover:bg-[#4d4d31]/20 hover:border-[#4d4d31] transition-all whitespace-nowrap cursor-pointer font-barlow tracking-wide"
          >
            Subscribe Free →
          </a>
        </div>

        {/* Social proof strip */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-8 text-[#e9eae4]/35 text-sm font-barlow">
          <div className="flex items-center space-x-2">
            <i className="ri-user-line text-base"></i>
            <span>Growing community of resellers</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-[#e9eae4]/15"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-mail-check-line text-base"></i>
            <span>Free to read on Substack</span>
          </div>
          <div className="hidden sm:block w-px h-4 bg-[#e9eae4]/15"></div>
          <div className="flex items-center space-x-2">
            <i className="ri-lock-line text-base"></i>
            <span>No spam, ever</span>
          </div>
        </div>
      </div>
    </section>
  );
}
